@if (visible()) {
  <nsp-icon
    [name]="iconName()"
    size="lg"
    class="cursor-help {{ colorClass() }}"
    [pTooltip]="text()"
    tooltipPosition="top"
    tooltipStyleClass="text-white"
    role="img"
    [attr.aria-label]="text()"
  />
}
